import requester from '@/utils/request'
export const statisticService = {
  getWithdrawList: (data: any) => requester.post('/user/withdraw/flow/list', data),
  getWithdrawDetail: (id: any) => requester.post('/user/withdraw/flow/detail', { id }),
  getRevenueDetail: (id: any) => requester.post('/user/revenue/flow/detail', { id }),
  getRevenueList: (data: any) => requester.post('/user/revenue/flow/list', data),
  getTotalRevenue: (sourceType: number | null) =>
    requester.post('/user/revenue/flow/statistic/cross/volume', { sourceType }),
  getBalance: () => requester.post('/common/creator/logic/current/balance'),
  getWithdrawStatistic: () => requester.post('/user/withdraw/flow/statistic/cross/volume'),
  // 获取创作者统计 cvr 信息
  queryCvrInfo: () => requester.post('/seller/creator-cvr/queryCvrInfo', {}),

  // query dispute list
  getDisputeList: (data: any) => requester.post('/user/revenue/flow/list/dispute', data),
  getDisputeCount: () => requester.post('/user/revenue/flow/dispute/count'),
  // 创作者Statics Payouts币种余额查询
  getPayoutsBalance: () => requester.post('/withdraw/statics/payouts/find-wallet-balance'),
}

export interface EarningItem {
  id?: any
  platformFeeEth?: number
  platformFeeUsd?: number
  purchaseAmountEth?: number
  purchaseAmountUsd?: number
  realRevenueEth?: number
  realRevenueUsd?: number
  revenueOccurrenceTime?: number
  // 0-subscribe 1-collection 2-message_media 3-tips 4-post
  sourceType?: 0 | 1 | 2 | 3 | 4 | 5
  sourceUserAddress?: string
  sourceUserCode?: string
  sourceUserUserName?: string
  status?: 0 | 1 | 2 // 0-pending, 1-available, 2-disputed
  transactionHash?: string
  currencyType?: 0 | 1 | 3 | 4 | 5 // 0: ETH, 1: USD 3:USDT 4: USDC 5: SOL
  statusTime?: number
  remark?: string
  result?: string
  description?: string
  blockedUsdtTransfer?: boolean
  payStatus?: 2 | 5 | 8 | 6 // success | disputed | risk | refund
  disputeFee?: number
  netAmount?: number
  domain?: string
}

export interface WithdrawDetail {
  addressFrom: string
  addressTo: string
  chain: number
  currencyType: 0 | 1 | 3 | 4 | 5 // 0: ETH, 1: USD 3:USDT 4: USDC 5: SOL
  gasFee: number
  id: number
  networkFee: number
  status: 0 | 1 | 2 // 0: success, 1: fail, 2: processing
  transactionHash: string
  withdrawOccurTime: number
  withdrawalAmount: number
  network: string
}

export interface WithdrawItem {
  currencyType: 0 | 1 | 3 | 4 | 5 // 0: ETH, 1: USD 3:USDT 4: USDC 5: SOL
  id: number
  status: number
  withdrawArrivalAmount: number
  withdrawOccurTime: number
}

export interface WalletBalanceVO {
  availableBalance: number
  availableSoonBalance: number
  currency: string
  payoutCompletedBalance: number
  label?: string
  value?: number | string
  name?: string
  type?: number
  icon?: string
  key?: string
  dot?: boolean
}

export interface RevenueStatistic {
  hasFiatPayout: boolean
  isWithdrawBlocked: boolean
  payoutTotalBalance: number
  walletBalanceVOList: WalletBalanceVO[]
}

export interface WithdrawStatistic {
  balanceEth: number
  balanceEthAsUsd: number
  balanceUsd: number
  balanceUsdPending: number
  userCode: string
  withdrawEthCompleted: number
  withdrawUsdCompleted: number
}

export interface DisputeItem {
  currencyType: number
  id: number
  platformFeeEth: number
  platformFeeUsd: number
  realRevenueEth: number
  realRevenueUsd: number
  revenueOccurrenceTime: number
  sourceType: number
  sourceUserAddress: string
  sourceUserCode: string
  sourceUserUserName: string
  status: number
}
